import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  VStack,
  Text,
  Box,
  HStack,
} from "@chakra-ui/react";
import Button from "components/Button/Button";

import Uploader, {
  Thumbs as UploadPreview,
} from "components/Uploader/Uploader";

import { ReactComponent as UploadIcon } from "assets/svg/camera.svg";
import { isEmpty } from "lodash";

const UploadProve = ({
  isOpen,
  onClose,
  isLoading,
  onConfirm,
  buttonText,
  file,
  onFileChange,
  disableSkip,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent bg="#F8F9FD" overflow="hidden" borderRadius="16px">
        <ModalHeader p="26px 0" textAlign="center" bg="white" fontSize="md">
          <HStack
            px="24px"
            alignItems="center"
            justifyContent={disableSkip ? "center" : "space-between"}
          >
            {!disableSkip && <Box minW="60px" />}
            <Text>Proof of Payment</Text>
            {!disableSkip && (
              <Button
                disabled={isLoading}
                isLoading={isLoading}
                minW="60px"
                onClick={onConfirm}
                bg="transparent"
                border="2px solid transparent"
                color="#03A438"
                alignSelf="flex-end"
              >
                Skip
              </Button>
            )}
          </HStack>
        </ModalHeader>
        {/* <ModalCloseButton /> */}
        <ModalBody p="24px 48px">
          <VStack>
            <Text textAlign="center" fontSize="md">
              Kindly upload your proof of payment here.
            </Text>

            <Uploader
              files={(file && [file]) ?? []}
              onFiles={(files) => onFileChange(files[0])}
              renderer={({
                rootProps,
                inputProps,
                isDragActive,
                isDragReject,
                files,
              }) => (
                <Box
                  border="1px dashed #B8C1EF"
                  bg="white"
                  minH="150px"
                  borderRadius="10px"
                  w="100%"
                  h="fit-content"
                  pos="relative"
                  overflow="hidden"
                  mt="20px"
                  cursor="pointer"
                  {...rootProps}
                >
                  <input {...inputProps} />

                  {isEmpty(files) && (
                    <VStack py="20px">
                      <Box as={UploadIcon} />

                      <Text
                        textAlign="center"
                        color={isDragReject ? "red.400" : "#4E4B66"}
                        fontSize="sm"
                      >
                        {!isDragActive && "Drag your file here or browse"}
                        {isDragActive &&
                          !isDragReject &&
                          "Drop it like it's hot!"}
                        {isDragReject && "File type not accepted, sorry!"}
                      </Text>

                      <Text textAlign="center" color="#4E4B66" fontSize="xs">
                        File format JPEG, PNG, PDF Size 15mb max
                      </Text>
                    </VStack>
                  )}

                  {!isEmpty(files) && <UploadPreview previewFiles={files} />}
                </Box>
              )}
            />
          </VStack>
        </ModalBody>

        <ModalFooter justifyContent="center" pb="30px" gridGap="14px">
          <Button
            disabled={isLoading}
            minW="120px"
            onClick={onClose}
            bg="transparent"
            border="2px solid transparent"
            color="#03A438"
          >
            {(buttonText && buttonText[0]) ?? "Cancel"}
          </Button>
          <Button
            disabled={!file || isLoading}
            isLoading={isLoading}
            minW="120px"
            onClick={onConfirm}
          >
            {(buttonText && buttonText[1]) ?? "Submit"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default UploadProve;
